var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.3333L14.5833 19.6875L10.8669 20.3632C9.65908 20.5828 8.56661 21.2194 7.77999 22.1619C6.99337 23.1045 6.5625 24.2932 6.5625 25.5208V29.8958C6.5625 30.2826 6.71615 30.6535 6.98964 30.927C7.26313 31.2005 7.63406 31.3542 8.02083 31.3542H26.9792C27.3659 31.3542 27.7369 31.2005 28.0104 30.927C28.2839 30.6535 28.4375 30.2826 28.4375 29.8958V25.5208C28.4375 24.2932 28.0066 23.1045 27.22 22.1619C26.4334 21.2194 25.3409 20.5828 24.1331 20.3632L20.4167 19.6875L17.5 23.3333Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 10.2083C24.0625 11.9488 23.3711 13.618 22.1404 14.8487C20.9097 16.0794 19.2405 16.7708 17.5 16.7708C15.7595 16.7708 14.0903 16.0794 12.8596 14.8487C11.6289 13.618 10.9375 11.9488 10.9375 10.2083C10.9375 8.46785 11.6289 6.79866 12.8596 5.56795C14.0903 4.33724 15.7595 3.64584 17.5 3.64584C19.2405 3.64584 20.9097 4.33724 22.1404 5.56795C23.3711 6.79866 24.0625 8.46785 24.0625 10.2083Z",
    fill: "#494949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlank);
export default __webpack_public_path__ + "static/media/user-blank.9506f626f537fd9122fb63806ad8e401.svg";
export { ForwardRef as ReactComponent };